<template>
  <div class="animated fadeIn list-of-cashflow">
    <b-card>
      <div slot="header">
        Inventory Balance
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="exportxls()">
            <i class="fa fa-file-excel-o"></i>
            Export
          </button>
          <button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </button>
        </div>
      </div>
      <b-row no-gutters>
        <b-col lg="7">
          <b-input-group>
            <b-input-group-prepend>
              <span class="p-2">Periode</span>
            </b-input-group-prepend>
            <vue-monthly-picker
              v-model="model.periode"
              dateFormat="MMMM YYYY"
              :monthLabels="monthLabels"
              @selected="onChangeMonth"
              style="width: 332px !important;"
            ></vue-monthly-picker>
            <b-input-group-prepend>
              <span class="pl-3 pt-2 pr-2">Inventory Group/Category</span>
            </b-input-group-prepend>
            <b-form-select
              v-model="model.headcategory"
              :plain="true"
              :options="headCategories"
            ></b-form-select>
          </b-input-group>
        </b-col>
        <b-col lg="3">
          <b-button class="btn btn-success ml-1" @click="process()">
            <i class="fa fa-play"></i> Process
          </b-button>
        </b-col>
      </b-row>
      <b-tabs card>
        <b-tab title="Summary" active>
          <b-card no-body>
            <template v-slot:header>
                <b-row v-if="(filterShow=='Hide')">
                  <b-col lg="4">
                      <b-input-group size="sm">
                          <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch></b-form-checkbox>
                            <b-input-group-prepend> <span class="pr-2">
                                <b> {{ filterShow }}</b>  Filter </span>
                            </b-input-group-prepend>
                          <b-form-input v-model="filter" type="search" placeholder="Type to Search"></b-form-input>
                          <b-input-group-append>
                              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                          </b-input-group-append>
                      </b-input-group>
                  </b-col>
                  <b-col lg="8">
                      <b-input-group size="sm" class="small">
                        <b-input-group-prepend > <span class="p-2 font-weight-bold">Filter On:</span></b-input-group-prepend>
                        <b-form-checkbox-group v-model="filterOn" class="mt-1">
                          <b-form-checkbox class="small"
                            v-for="(item,index) in tblSmry.fields.filter(x=>x.filterable)"
                            :key="index"
                            :value="item.key"
                          >{{item.labelFilter||item.label}}</b-form-checkbox>
                        </b-form-checkbox-group>
                      <span class="text-muted small p-2" style="margin-left:10px;">Leave all unchecked to filter on all data</span>
                      </b-input-group>
                  </b-col>
                </b-row>
                <b-row v-else>
                  <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch class="ml-3">
                    <b> {{ filterShow }}</b>  Filter
                  </b-form-checkbox>
                </b-row>
            </template>
            <b-table
              class="mb-0"
              ref="tableOri"
              outlined
              responsive
              striped
              hover
              bordered
              style="font-size:smaller;"
              :items="smrydata"
              :fields="tblSmry.fields"
              :current-page="tblSmry.page"
              :per-page="tblSmry.limit"
              :sort-by.sync="tblSmry.sortBy"
              :sort-desc.sync="tblSmry.sortDesc"
              :filter="filter"
              :filterIncludedFields="filterOn"
              @filtered="onFiltered"
              show-empty
            >
              <template v-slot:thead-top="data">
                <b-tr>
                  <b-th colspan="2"></b-th>
                  <b-th variant="primary" colspan="2" class="text-center">BEGINING BALANCE</b-th>
                  <b-th variant="primary" colspan="2" class="text-center">DEBIT (IN/RECEIPT)</b-th>
                  <b-th variant="primary" colspan="2" class="text-center">CREDIT (ISSUED)</b-th>
                  <b-th variant="primary" colspan="2" class="text-center">ENDING BALANCE</b-th>
                </b-tr>
              </template>
              <template v-slot:head(valueaw)="data">
                <span>Value ({{uanguser}})</span>
              </template>
              <template v-slot:head(valuenew)="data">
                <span>Value ({{uanguser}})</span>
              </template>
              <template v-slot:head(valueOut)="data">
                <span>Value ({{uanguser}})</span>
              </template>
              <template v-slot:head(valueak)="data">
                <span>Value ({{uanguser}})</span>
              </template>
              <template
                v-slot:cell(partnumber)="data"
              >{{data.item.partnumber}} | {{data.item.itemname}}</template>
              <template v-slot:cell(qtyaw)="data">
                <span
                  v-if="data.item.qtyaw"
                >{{data.item.qtyaw | numFormat('0,0.00')}} {{data.item.invunitom}}</span>
              </template>
              <template v-slot:cell(valueaw)="data">
                <span v-if="data.item.valueaw">{{data.item.valueaw | numFormat('0,0.00')}}</span>
              </template>
              <template v-slot:cell(qtynew)="data">
                <span
                  v-if="data.item.qtynew"
                >{{data.item.qtynew | numFormat('0,0.00')}} {{data.item.invunitom}}</span>
              </template>
              <template v-slot:cell(valuenew)="data">
                <span v-if="data.item.valuenew">{{data.item.valuenew | numFormat('0,0.00')}}</span>
              </template>
              <template v-slot:cell(qtyOut)="data">
                <span
                  v-if="data.item.qtyOut"
                >{{data.item.qtyOut | numFormat('0,0.00')}} {{data.item.invunitom}}</span>
              </template>
              <template v-slot:cell(valueOut)="data">
                <span v-if="data.item.valueOut">{{data.item.valueOut | numFormat('0,0.00')}}</span>
              </template>
              <template v-slot:cell(qtyak)="data">
                <span
                  v-if="data.item.qtyak"
                >{{data.item.qtyak | numFormat('0,0.00')}} {{data.item.invunitom}}</span>
              </template>
              <template v-slot:cell(valueak)="data">
                <span v-if="data.item.valueak">{{data.item.valueak | numFormat('0,0.00')}}</span>
              </template>
            </b-table>
            <b-row>
              <b-col md="4">
                <div class="ml-1">
                  Showing {{(tblSmry.page - 1) * tblSmry.limit + 1}}
                  to
                  <span
                    v-if="((tblSmry.page * tblSmry.limit)>tblSmry.total)"
                  >{{tblSmry.total}}</span>
                  <span v-else>{{tblSmry.page * tblSmry.limit}}</span>
                  of {{tblSmry.total}} entries.
                    <span class="mr-1">limit per page :</span>
                  <input type="number" style="width:80px;" v-model="tblSmry.limit"/>
                </div>
                <b-pagination
                  class="ml-1"
                  :total-rows="tblSmry.total"
                  :per-page="tblSmry.limit"
                  v-model="tblSmry.page"
                ></b-pagination>

              </b-col>
              <b-col md="2">
                Begining Balance :
                <span
                  class="input-group-text"
                >{{uanguser}} {{subtotal.totalAw | numFormat('0,0.00')}}</span>
              </b-col>
              <b-col md="2">
                Debit :
                <span
                  class="input-group-text"
                >{{uanguser}} {{subtotal.totalNew | numFormat('0,0.00')}}</span>
              </b-col>
              <b-col md="2">
                Credit :
                <span
                  class="input-group-text"
                >{{uanguser}} {{(subtotal.totalPay) | numFormat('0,0.00')}}</span>
              </b-col>
              <b-col md="2">
                Ending :
                <span
                  class="input-group-text" align="right"
                >{{uanguser}} {{(subtotal.totalAk) | numFormat('0,0.00')}}</span>
              </b-col>
            </b-row>
          </b-card>
        </b-tab>
        <b-tab title="Detail Available Items">
          <b-card no-body>
            <template v-slot:header>
                <b-row v-if="(filterDetailShow=='Hide')">
                  <b-col lg="4">
                      <b-input-group size="sm">
                          <b-form-checkbox v-model="filterDetailShow" value="Hide" unchecked-value="Show" switch></b-form-checkbox>
                            <b-input-group-prepend> <span class="pr-2">
                                <b> {{ filterDetailShow }}</b>  Filter </span>
                            </b-input-group-prepend>
                          <b-form-input v-model="filterDetail" type="search" placeholder="Type to Search"></b-form-input>
                          <b-input-group-append>
                              <b-button :disabled="!filterDetail" @click="filterDetail = ''">Clear</b-button>
                          </b-input-group-append>
                      </b-input-group>
                  </b-col>
                  <b-col lg="8">
                      <b-input-group size="sm" class="small">
                        <b-input-group-prepend > <span class="p-2 font-weight-bold">Filter On:</span></b-input-group-prepend>
                        <b-form-checkbox-group v-model="filterOnDetail" class="mt-1">
                          <b-form-checkbox class="small"
                            v-for="(item,index) in tbldetail.fields.filter(x=>x.filterable)"
                            :key="index"
                            :value="item.key"
                          >{{item.label}}</b-form-checkbox>
                        </b-form-checkbox-group>
                        <span class="text-muted small p-2" style="margin-left:10px;">Leave all unchecked to filter on all data</span>
                      </b-input-group>
                  </b-col>
                </b-row>
                <b-row v-else>
                  <b-form-checkbox v-model="filterDetailShow" value="Hide" unchecked-value="Show" switch class="ml-3">
                    <b> {{ filterDetailShow }}</b>  Filter
                  </b-form-checkbox>
                </b-row>
            </template>

            <b-table
              class="mb-0"
              ref="tableOri"
              outlined
              responsive
              striped
              hover
              bordered
              style="font-size:smaller;"
              :items="detaildata"
              :fields="tbldetail.fields"
              :current-page="tbldetail.page"
              :per-page="tbldetail.limit"
              :sort-by.sync="tbldetail.sortBy"
              :sort-desc.sync="tbldetail.sortDesc"
              :filter="filterDetail"
              :filterIncludedFields="filterOnDetail"
              @filtered="onFilteredDetail"
              show-empty
            >
              <template v-slot:thead-top="data">
                <b-tr>
                  <b-th colspan="6"></b-th>
                  <b-th variant="primary" colspan="3" class="text-center">ENDING BALANCE</b-th>
                </b-tr>
              </template>

              <template v-slot:head(purcOrderNo)="data">
                <span>
                  PO. Number
                  <br />& Supplier DO#
                </span>
              </template>

              <template v-slot:head(serialNum)="data">
                <span>
                  Serial Number
                  <br />& Expired Date
                </span>
              </template>
              <template v-slot:head(namaStore)="data">
                <span>
                  Store &
                  <br />Shelft/Rack
                </span>
              </template>

              <template v-slot:head(invValue)="data">
                <span>
                  Value
                  <br />
                  ({{uanguser}})
                </span>
              </template>
              <template
                v-slot:cell(partnumber)="data"
              >{{data.item.partnumber}} | {{data.item.itemname}}</template>
              <template v-slot:cell(recivDate)="data">
                <span v-if="data.item.recivDate">{{data.item.recivDate | moment("DD MMM YYYY")}}</span>
              </template>
              <template v-slot:cell(purcOrderNo)="data">
                {{data.item.purcOrderNo}}
                <span
                  v-if="data.item.vndShipNo"
                >&nbsp;,&nbsp; {{data.item.vndShipNo}}</span>
              </template>
              <template v-slot:cell(serialNum)="data">
                <p v-if="data.item.serialNum" style="margin:0; padding:0;">{{data.item.serialNum}}</p>
                <p
                  v-if="data.item.expirDate"
                  style="margin:0; padding:0;"
                >{{data.item.expirDate | moment("DD MMM YYYY")}}</p>
              </template>
              <template v-slot:cell(namaStore)="data">
                {{data.item.namaStore}}
                <p style="margin:0; padding:0;">{{data.item.shelfNo}}</p>
              </template>
              <template
                v-slot:cell(qtyAvail)="data"
              >{{data.item.qtyAvail | numFormat('0,0.00')}} {{data.item.invunitom}}</template>
              <template
                v-slot:cell(qtyTransfer)="data"
              >({{data.item.qtyTransfer | numFormat('0,0.00')}})</template>
              <template v-slot:cell(invValue)="data">{{data.item.invValue | numFormat('0,0.00')}}</template>
            </b-table>
            <b-row class="mt-2">
              <b-col cols="4">
                <div class="ml-1">
                  Showing {{(tbldetail.page - 1) * tbldetail.limit + 1}}
                  to
                  <span
                    v-if="((tbldetail.page * tbldetail.limit)>tbldetail.total)"
                  >{{tbldetail.total}}</span>
                  <span v-else>{{tbldetail.page * tbldetail.limit}}</span>
                  of {{tbldetail.total}} entries.
                </div>
              </b-col>
              <b-col cols="4" align="center">
                <span class="mr-1">limit per page :</span>
              <input type="number" style="width:80px;" v-model="tbldetail.limit"/>
              </b-col>
              <b-col cols="4">
                <b-pagination
                  class="ml-1"
                  align="right"
                  :total-rows="tbldetail.total"
                  :per-page="tbldetail.limit"
                  v-model="tbldetail.page"
                ></b-pagination>
              </b-col>
            </b-row>
          </b-card>
        </b-tab>
      </b-tabs>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
    <b-modal v-model="showReport" size="xl" scrollable  title="Preview as PDF" ok-only>
      <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
  </div>
</template>

           

<style lang="scss" scoped>
.report-wraper {
  width: 100%;
  overflow-x: auto;
  overflow-y: auto;

  table {
    font-size: smaller;
    th {
      border-bottom: 1px solid #d1d1d1;
      padding: 0 15px;
      height: 30px;
      background: #e8e8e8;
    }
    tbody tr:hover {
      background-color: rgba(91, 192, 222, 0.2) !important;
      cursor: default;
    }

    td {
      border-bottom: 1px solid #d1d1d1;
      padding: 0 10px;
      height: 25px;
    }

    td.tebal {
      font-weight: bold;
    }

    td.subtotal {
      border-top: 2px solid #000 !important;
    }

    td.total {
      border-top: 2px solid #000 !important;
      background: #e6e6e6 !important;
    }

    td.grdtotal {
      border-top: 2px solid #000 !important;
      border-bottom: 2px double #000 !important;
      background: #e6e6e6 !important;
    }
  }
}
iframe {
  border: 1px solid #ccc;
  width: 100%;
  height: 11in;
}
</style>

<script>
import moment from "moment";
import VueMonthlyPicker from "vue-monthly-picker";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import logistic_rpt from "../../apis/logistic_rpt";
import dropdown from "../../data/dropdown";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    model: {
      tgl1: { required },
      tgl2: { required },
    }
  },
  data() {
    return {
      horizontal: true,
      isLoading: false,
      showReport: false,
      reportUrl: null,
      model: {headcategory:'', kodeacc:'', namaacc:'',tgl1:'',tgl2:'',
        periode: moment(this.$store.state.user.tglaktif, "YYYY-MM-DD")
          .add(1, "M")
          .subtract(1, "day")
      },
      uanguser: this.$store.state.user.matauang,
      monthLabels: dropdown.monthLabels,
      smrydata: [],
      tblSmry: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
        fields: [
          {
            key: "partnumber",
            label: "Master Item",
            sortable: true,
            filterable: true
          },
          {
            key: "nmcategory",
            label: "Category",
            sortable: true,
            filterable: true
          },
          {
            key: "qtyaw",
            label: "Qty",
            labelFilter: "Begining Qty",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "valueaw",
            label: "Value",
            labelFilter: "Begining Value",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "qtynew",
            label: "Qty",
            labelFilter: "Debit Qty",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "valuenew",
            label: "Value",
            labelFilter: "Debit Value",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "qtyOut",
            label: "Qty",
            labelFilter: "Credit Qty",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "valueOut",
            label: "Value",
            labelFilter: "Credit Value",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "qtyak",
            label: "Qty",
            labelFilter: "Ending Qty",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "valueak",
            label: "Value",
            labelFilter: "Ending Value",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          }
        ]
      },
      filterShow: "Show",
      filter: null,
      filterOn: [],
      // end smry
      detaildata: [],
      tbldetail: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
        fields: [
          {
            key: "partnumber",
            label: "Master Item",
            sortable: true,
            filterable: true
          },
          {
            key: "nmcategory",
            label: "Category",
            sortable: true,
            filterable: true
          },
          {
            key: "recivDate",
            label: "Receipt date",
            sortable: true,
            filterable: true
          },
          {
            key: "purcOrderNo",
            label: "PO. Number",
            sortable: true,
            filterable: true
          },
          {
            key: "serialNum",
            label: "Serial Number",
            sortable: true,
            filterable: true
          },
          {
            key: "namaStore",
            label: "Store",
            sortable: true,
            filterable: true
          },
          {
            key: "qtyAvail",
            label: "Qty Avail",
            sortable: true,
            filterable: true,
            tdClass: "text-right"
          },
          {
            key: "qtyTransfer",
            label: "On Transfer",
            sortable: true,
            filterable: true,
            tdClass: "text-right"
          },
          {
            key: "invValue",
            label: "Value",
            sortable: true,
            filterable: true,
            tdClass: "text-right"
          }
        ]
      },
      filterDetailShow: "Show",
      filterDetail: null,
      filterOnDetail: [],
      subtotal: {
        posting: -1,
        totalAw: 0,
        totalNew: 0,
        totalPay: 0,
        totalAk: 0
      },
      headCategories: [],
      itemCategories: []
    };
  },
  components: { VueMonthlyPicker, Loading },
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    headcategory() {
        return this.model.headcategory;
    },
  },
  watch:{
    headcategory: function(newval) {
      const obj=this.headCategories.find(d => d.value === newval);
      if (obj) {
        this.model.namaacc=obj.text || '';
        this.model.kodeacc=obj.kodeacc;
      }
    },
  },  

  created: async function() {
    this.model.periode = moment(this.$store.state.user.tglaktif, "YYYY-MM-DD")
      .add(1, "M")
      .subtract(1, "day");
    this.model.tgl1 = this.$store.state.user.tglaktif;
    this.model.tgl2 = this.model.periode.format("YYYY-MM-DD");
    const a = await logistic_rpt.inventorygroup();
    this.onChangeMonth();
      this.headCategories = a.reduce((newArr,item) =>{
            newArr.push(item);
            return newArr;
        },[{ value: '', text: '--- ALL ---'}]);
  },
  methods: {
    onFilteredDetail(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tbldetail.total = filteredItems.length;
      this.tbldetail.page = 1;
    },
    clearFilterDetail() {
      this.filterOnDetail = [];
      this.filterDetail = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblSmry.total = filteredItems.length;
      this.tblSmry.page = 1;
    },
    clearFilter() {
      this.filterOn = [];
      this.filter = "";
    },
    updateTgl1: function() {
      var tgl2 = moment(this.model.tgl2, "YYYY-MM-DD");
      this.model.tgl1 = `${tgl2.format("YYYY-MM")}-01`;
      // this.tahun=tgl2.format('YYYY');
      // this.$forceUpdate();
      this.model.tgl2 = tgl2.endOf("month").format("YYYY-MM-DD");
      // console.log("this.model.tgl2 : ", this.model.tgl2);
    },
    onChangeMonth: async function() {
      var tgl = this.model.periode;
      this.model.tgl1 = tgl.startOf("month").format("YYYY-MM-DD");
      this.model.tgl2 = tgl.endOf("month").format("YYYY-MM-DD");
      this.subtotal.posting = -1;
      // console.log("this.model : ", this.model);
      this.$forceUpdate();
    },

    process: async function() {
      if (this.invalidModel) {
        toastr.error("Please fill the form correctly.");
      } else {
        this.isLoading = true;
        try {
          const result = await logistic_rpt.balance(this.model);
          // console.log('inventory balance : ', result);
          this.smrydata = result[0];
          let totalAw = 0,
            totalNew = 0,
            totalPay = 0,
            totalAk = 0;
          this.smrydata.map(data => {
            (totalAw += data.valueaw),
              (totalNew += data.valuenew),
              (totalPay += data.valueOut),
              (totalAk += data.valueak);
          });
          this.subtotal.totalAw = totalAw;
          this.subtotal.totalNew = totalNew;
          this.subtotal.totalPay = totalPay;
          this.subtotal.totalAk = totalAk;
          this.detaildata = result[1];
          this.tbldetail.total = result[1].length;
          this.tblSmry.total =  result[0].length;
        } catch (error) {
          if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
        this.isLoading = false;
      }
    },
    exportxls: async function() {
      if (this.invalidModel) {
        toastr.error("Please fill the form correctly.");
      } else {
        this.isLoading = true;
        try {
          const response = await logistic_rpt.balanceexport(this.model);
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    close() {
      router.push("home");
    }
  }
};
</script>
